import useCountStProjectTasks from "../../swrCustomHooks/useCountStProjectTasks"
import {useTranslation} from "react-i18next"
import arrowLeftBlackIcon from "../../assets/icon/arrow-left-black.svg"
import arrowLeftGrey from "../../assets/icon/arrow-left-grey.svg"
import arrowRightBlackIcon from "../../assets/icon/arrow-right-black.svg"
import arrowRightGrey from "../../assets/icon/arrow-right-grey.svg"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"

export default function ProjectDashboardFooter({projectID}) {
    const {t} = useTranslation()
    const {nwDashboardContext, setNwDashboardAction} = useNwDashboardContext()
    const {countStProjectTasks, isLoadingCountStProjectTasks, isErrorCountStProjectTasks} = useCountStProjectTasks(projectID)
    const options = []

    try {
        var index = 1
        while (index < (Math.ceil(countStProjectTasks / 8) + 1)) {
            options.push({value: index, label: index})
            index++
        }
    } catch {}

    const handlePage = (value) => {
        const selectPage = document.getElementById("selectPage")
        if (value === "-" && nwDashboardContext.projectPage > 1) {
            selectPage.value = parseInt(nwDashboardContext.projectPage - 1)
            setNwDashboardAction({type: "NW_DASHBOARD_SET_PROJECT_PAGE", payload: {projectPage: parseInt(nwDashboardContext.projectPage) - 1}})
        } else if (value === "+" && nwDashboardContext.projectPage < Math.ceil(countStProjectTasks / 8)) {
            selectPage.value = parseInt(nwDashboardContext.projectPage + 1)
            setNwDashboardAction({type: "NW_DASHBOARD_SET_PROJECT_PAGE", payload: {projectPage: parseInt(nwDashboardContext.projectPage) + 1}})
        }
    }

    if (isErrorCountStProjectTasks || isLoadingCountStProjectTasks || countStProjectTasks.message || countStProjectTasks <= 8) return null
    return (
        <>
        <div className="SECTION PROJECT-DASHBOARD-FOOTER">
            <div className="left-content">
                <select id="selectPage" name="selectPage" onChange={(e) => setNwDashboardAction({type: "NW_DASHBOARD_SET_PROJECT_PAGE", payload: {projectPage: parseInt(e.target.value)}})}>
                    {options.map((option, index) => {
                        if ((index + 1) === nwDashboardContext.projectPage) {
                            return <option selected key={`option-${index}`} value={option.value}>{option.label}</option>
                        } else {
                            return <option key={`option-${index}`} value={option.value}>{option.label}</option>
                        }
                    })}
                </select>
                <p>sur {Math.ceil(countStProjectTasks / 8)} page{Math.ceil(countStProjectTasks / 8) >= 2 && "s"}</p>
            </div>
            <div className="right-content">
                <img src={(Math.ceil(countStProjectTasks / 8) === 1 || nwDashboardContext.projectPage === 1) ? arrowLeftGrey : arrowLeftBlackIcon} alt="" onClick={() => handlePage("-")} title={t("Previous page")}/>
                <img src={(Math.ceil(countStProjectTasks / 8) === 1 || nwDashboardContext.projectPage === Math.ceil(countStProjectTasks / 8)) ? arrowRightGrey : arrowRightBlackIcon} alt="" onClick={() => handlePage("+")} title={t("Next page")}/>
            </div>
        </div>
        </>
    )
}